// extracted by mini-css-extract-plugin
module.exports = {"element":"MenuItem_element__d6TVV"};